module.exports = __webpack_public_path__ + "static/logo-b7f2289919c2083e4a5e10b183650b86.svg";